module.exports = __webpack_public_path__ + "img/galery-inge-v6-1.9a335ef7.jpg";